import { UserButton } from "@clerk/react";
import { useAuth } from "@/context/AuthContext";
import { useTenant } from "@/context/TenantContext";
import NotificationPanel from "@/features/notifications/components/NotificationPanel";

export default function Header() {
    const { user } = useAuth();
    const { tenant } = useTenant();

    return (
        <header className="flex h-16 items-center justify-between border-b border-gray-200 bg-white px-6">
            {/* Left: Plan badge */}
            <div className="flex items-center gap-2">
                {tenant && (
                    <span className="rounded-full bg-indigo-100 px-2.5 py-0.5 text-xs font-medium text-indigo-700 capitalize">
                        {tenant.plan}
                    </span>
                )}
            </div>

            {/* Right: User actions */}
            <div className="flex items-center gap-4">
                {/* Notifications — real dropdown */}
                <NotificationPanel />

                {/* User name */}
                <div className="hidden sm:block text-sm text-right mr-1">
                    <p className="font-medium text-gray-900">{user?.name}</p>
                </div>

                {/* Clerk UserButton — avatar, profile, sign out */}
                <UserButton
                    appearance={{
                        elements: {
                            avatarBox: "h-8 w-8",
                        },
                    }}
                />
            </div>
        </header>
    );
}